import styled from 'styled-components';
import { Button } from '../index';
import { colors } from '../../assets/variables';

const Btn = styled(Button)`
  background: white;
  box-shadow: inset 0 0 0 1px ${colors.primary};
  color: ${colors.primary};
  :hover,
  :focus {
    color: ${colors.primary};
    box-shadow: inset 0 0 0 1px ${colors.primary};
    background-color: ${colors.action};
    & svg {
      path {
        fill: white;
      }
    }
  }
`;
export default {
  Btn,
};
